import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  sidebar: false,
  notification: false,
  menuOpen: [],
  user: {},
  menu: [],
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    openSidebar: (state: { sidebar: boolean }) => {
      state.sidebar = !state.sidebar;
    },
    closeSidebar: (state: { sidebar: boolean }) => {
      state.sidebar = false;
    },
    openMenu: (state, { payload }) => {
      state.menuOpen = [payload];
    },
    closeMenu: (state) => {
      state.menuOpen = [];
    },
    openNotification: (state: { notification: any }, { payload }: any) => {
      state.notification = payload;
    },
    closeNotification: (state: { notification: boolean }) => {
      state.notification = false;
    },
    signIn: (state: { user: any }, { payload }: any) => {
      state.user = payload;
    },
    signOut: (state: { user: null; menu: any }) => {
      state.user = null;
      state.menu = [];
    },
    setMenu: (state: { menu: any }, { payload }: any) => {
      state.menu = payload;
    },
    reloadMenu: (state: { menu: any }) => {
      state.menu = []
    },
    changeMemberComparisonSelector: (
      state: { member_comparison_selector: any },
      { payload }: any
    ) => {
      state.member_comparison_selector = payload;
    },
  },
});

export const actions = globalSlice.actions;

export default globalSlice.reducer;
